/** API base URL — set per environment via VITE_API_BASE_URL (.env.development / .env.production). */
export const API_BASE_URL: string =
  (import.meta.env.VITE_API_BASE_URL as string | undefined)?.replace(/\/$/, '') ||
  'https://dev.api.scanify.es';

/** Poll / timing constants (SCN-612). */
export const STATUS_POLL_MS = 5_000;
export const PLAYLIST_POLL_MS = 30_000;
export const HEARTBEAT_MS = 30_000;

/** Crossfade duration between slides — must match the CSS transition in index.css. */
export const CROSSFADE_MS = 500;

/** Fallback per-slide duration when neither the slide nor the playlist specifies one. */
export const FALLBACK_SLIDE_MS = 10_000;
